import { render, staticRenderFns } from "./SelectMonthYear.component.vue?vue&type=template&id=96ffcf18"
import script from "./SelectMonthYear.component.vue?vue&type=script&lang=js"
export * from "./SelectMonthYear.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports